module.exports = __webpack_public_path__ + "assets/img/workLeft1.f8576a95.png";